import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/CH1.webp',
  './images/CH2.webp',
  './images/CH3.webp',
  './images/CH4.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Guangzhou, also known as Canton, is a bustling city in southern China known for its rich history, vibrant markets, and legendary Cantonese cuisine.

Top places to visit:

• Canton Tower – One of the tallest towers in the world with observation decks and a sky drop ride.
• Chen Clan Ancestral Hall – A beautiful example of traditional Cantonese architecture and folk art.
• Shamian Island – A peaceful island with colonial-era buildings and riverside views.
• Yuexiu Park – Home to the Five Rams Statue and the Zhenhai Tower.
• Baiyun Mountain – A scenic spot for hiking with panoramic city views.
• Sacred Heart Cathedral – A striking Gothic church built entirely of granite.
• Qingping Market – A famous market for Chinese medicine, herbs, and dried goods.
• Beijing Road – A popular shopping street with archaeological ruins under glass walkways.
• Haixinsha Island – A scenic park and former Asian Games venue by the Pearl River.
• Chimelong Paradise – A massive amusement park with rides, a safari, and a water park.

Guangzhou is a haven for food lovers, offering dishes like dim sum, roast goose, wonton noodles, and fresh seafood.`,

    zh: `广州，又称“花城”，是中国南方的重要城市，以悠久的历史、热闹的市集和著名的粤菜文化而闻名。

推荐景点：

• 广州塔（小蛮腰）– 世界著名高塔，可俯瞰城市全景，体验高空速降。
• 陈家祠 – 粤派建筑艺术的代表之作，雕刻精美。
• 沙面岛 – 洋楼林立、绿树成荫，是休闲漫步的好去处。
• 越秀公园 – 有五羊雕像和镇海楼，是广州市的象征。
• 白云山 – 市区近郊的天然氧吧，适合徒步登山。
• 圣心大教堂 – 全石结构的哥特式教堂，庄严壮观。
• 清平市场 – 中药材和干货的集散地，充满市井气息。
• 北京路 – 集购物、美食与历史遗迹于一体的商业街。
• 海心沙岛 – 亚洲运动会主场地，如今是美丽的滨江公园。
• 长隆欢乐世界 – 综合性主题乐园，有游乐项目、动物园和水上乐园。

广州也是美食的天堂，从早茶点心到炭烧烧鹅，各种粤味美食令人垂涎欲滴。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/CH1.webp" className="travel-image2" />
          <img src="./images/CH2.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Guangzhou</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Guangzhou</h2>
          <p className="carousel-subheading">
            Experience southern charm, cultural treasures, and world-famous Cantonese flavors.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
